import { createPublicTypedEventPage } from "../typedEvents/PublicTypedEventPage";

// The shared implementation, typed 'camp'. Change behavior in
// typedEvents/PublicTypedEventPage.tsx, once, for every type.
export default createPublicTypedEventPage("camp");
